import { useCache } from "@effektify/cache";
const useCardGoals = configGoals => {
  const {
    goals
  } = useCache();
  let t0;
  bb0: {
    if (!configGoals || !Array.isArray(configGoals) || configGoals.length === 0) {
      t0 = null;
      break bb0;
    }
    const {
      data,
      isPending
    } = goals;
    if (isPending || !data || Object.keys(data).length === 0) {
      t0 = null;
      break bb0;
    }
    t0 = data;
  }
  return t0;
};
export { useCardGoals as default };